<template>
  <div class="base-dressing single-step">
    <div class="heading">
      <h2>{{ $ml.get(`Base dressing (Recommendations)`) }}</h2>
      <!-- <app-btn @click="getPdf" v-if="loaded">
        {{$ml.get(`PRINT REPORT`)}}
      </app-btn> -->
    </div>
    <app-loading :loading="!loaded" :isTimeOut="true" @refresh="refresh">

      <FirstSection v-model="nutFlag" @recalculate="recFlag = !recFlag"/>
      <SelectedFertilizer
        :result="result ? result.data : null"
        :recFlag="recFlag"
        :loading="loading"
        v-if="nutFlag"
        @recalculate="recalculate"
        @manual="manual"
        />
      <ApliedNutrients :value="result" :loading="loading" v-if="result != null && nutFlag"/>
    </app-loading>
  </div>
</template>

<script>
import API from '@/api'
import ApliedNutrients from './ApliedNutrients'
import FirstSection from './FirstSection'
import SelectedFertilizer from './SelectedFertilizer'

export default {
  data() {
    return {
      loaded: false,
      result: null,
      loading: false,
      nutFlag: false,
      recFlag: false
    }
  },
  created() {
    this.loaded = false;
    this.sync();

    // this.getPdf();
  },
  methods: {
    refresh () {
      this.loaded = false;
      this.sync();
    },
    manual() {
      this.loading = true;
      console.log(this.result.data.SelectedFertilizers.Fertilizers[0].Concentration);
      const units = this.$store.getters['user/data'].units;
      if(units.toLowerCase() === 'us') {
        this.result.data.SelectedFertilizers.Fertilizers.forEach(el => {
          el.Concentration = this.$store.getters['unit/unConvert']('kg', el.Concentration)
        })
      }
      console.log(this.result.data.SelectedFertilizers.Fertilizers[0].Concentration);
      return API.program.manualBaseDressing(this.$route.params.programId, this.result)
        .then(res => {
          let friendAlerts = res.data.data.FriendlyAlerts.Alerts
          let nFormAlerts = res.data.data.N_FormsAlert.Alerts
          let severeAlerts = res.data.data.SevereAlerts.Alerts
          if (friendAlerts) {
            friendAlerts.forEach(e => {
              this.$notify({
                group: 'notices',
                text: this.$ml.get(e.Message),
                type: 'warn'
              })
            })
          } if (nFormAlerts) {
            nFormAlerts.forEach(e => {
              this.$notify({
                group: 'notices',
                text: this.$ml.get(e.Message),
                type: 'warn'
              })
            })
          } if (severeAlerts) {
            severeAlerts.forEach(e => {
              this.$notify({
                group: 'notices',
                text: this.$ml.get(e.Message),
                type: 'warn'
              })
            })
          }
          this.$store.dispatch('program/base-dressing/onUpdate');
          this.result = res.data;
          this.loading = false;
        });
      this.loading = false;
    },
    // async getPdf() {
    //   var result = await API.pdf.getPdfForBaseDressing(this.$route.params.programId);
    //   var blob = new Blob([result.data], {type: 'application/pdf'});
    //   var link = document.createElement('a');
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = 'baseDressing.pdf';
    //   link.click();
    // },

    sync () {
      this.$store.dispatch('program/loadProgramById', this.$route.params.programId).then(async () => {
        await Promise.all([
          this.$store.dispatch('program/base-dressing/selectNPKs'),
          this.$store.dispatch('program/base-dressing/getNutrients'),
        ]);

        if(!this.$store.getters['program/base-dressing/nutrients'] || Object.keys(this.$store.getters['program/base-dressing/nutrients']).length == 0) {
          await this.$store.dispatch('program/base-dressing/initNutrients');
        } else {
          await this.getResult();
        }
      }).finally(() => {
        this.loaded = true;
      });
    },
    getResult() {
      return API.program.getBaseDressingResult(this.$route.params.programId).then(res => {
        this.result = res.data;
        this.loading = false;
        let friendAlerts = res.data.data.FriendlyAlerts.Alerts
        let nFormAlerts = res.data.data.N_FormsAlert.Alerts
        let severeAlerts = res.data.data.SevereAlerts.Alerts
          if (friendAlerts) {
            friendAlerts.forEach(e => {
              this.$notify({
                group: 'notices',
                text: this.$ml.get(e.Message),
                type: 'warn'
              })
            })
          } if (nFormAlerts) {
            nFormAlerts.forEach(e => {
              this.$notify({
                group: 'notices',
                text: this.$ml.get(e.Message),
                type: 'warn'
              })
            })
          } if (severeAlerts) {
            severeAlerts.forEach(e => {
              this.$notify({
                group: 'notices',
                text: this.$ml.get(e.Message),
                type: 'warn'
              })
            })
          }
        // this.$store.dispatch('program/base-dressing/processConcentrations');
        // this.$store.dispatch('program/base-dressing/onUpdate');
      }).catch(err => {
        // this.result = null;
        // this.$notify({
        //   group: 'notices',
        //   title: this.$ml.get(`Please fill required data in previous steps!`),
        //   type : 'error',
        // });
        // }
      })
    },


    processConcentrations() {

    },


    recalculate(selectedFertilizers) {
      // console.log(selectedFertilizers);
      if(selectedFertilizers.length <= 0) {
        this.result = null;
        this.loading = false;
        return;
      }
      let data = {
        data: selectedFertilizers,
        programId: this.$store.getters['program/data'].id,
      };
      this.loading = true;

      return API.fertilizers.updateFertilizersBaseDressing(data).then(res => {
        return this.$store.dispatch('program/base-dressing/saveNutrients').then(res => {
          this.getResult();
          this.$store.dispatch('program/base-dressing/onUpdate');
        }).catch(err => {
          this.$notify({
            group: 'notices',
            title: this.$ml.get(`Please fill required data in previous steps!`),
            type : 'error',
          });
        })
      });
    },
  },
  components: {
    ApliedNutrients,
    FirstSection,
    SelectedFertilizer,
  },
  computed: {
    // ...mapGetters({
    //   nutrients: 'program/base-dressing/nutrients',
    //   form: 'program/base-dressing/nutrientsForm',
    // }),
  },
  watch: {
    nutFlag: function (val) {
      // console.log(val);
    }
  }
}
</script>

<style lang="scss" scoped>

.base-dressing {
  .app-loading {
    min-height: 400px;
    padding-top: 24px;
  }

  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

</style>
